export default "__VITE_ASSET__9ee61b4b__"